import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useThemeStore } from '@/stores/themeStore';
import { LoginPage } from '@/pages/LoginPage';
import { PortalPage } from '@/pages/PortalPage';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { KanbanPageSimple } from '@/pages/KanbanPageSimple';
import { TitulosPage } from '@/pages/TitulosPage';
import { UsersPage } from '@/pages/UsersPage';
import { CompaniesPage } from '@/pages/CompaniesPage';
import { ConfigPage } from '@/pages/ConfigPage';
import { ImportPage } from '@/pages/ImportPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { KanbanEtapasPage } from '@/pages/KanbanEtapasPage';
import { KanbanValidationPage } from '@/pages/KanbanValidationPage';
import { TestPage } from '@/pages/TestPage';
import { ClientesFornecedoresPageSimple } from '@/pages/ClientesFornecedoresPageSimple';
import LogAcessoPage from '@/pages/LogAcessoPage';
import EmailAutomationPage from '@/pages/EmailAutomationPage';
import { EmailReportsPage } from '@/pages/EmailReportsPage';
import { EmailABTestingPage } from '@/pages/EmailABTestingPage';
import { EmailPersonalizationPage } from '@/pages/EmailPersonalizationPage';
import EmailAnalyticsDashboard from '@/pages/EmailAnalyticsDashboard';
import WhatsAppIntegrationPage from '@/pages/WhatsAppIntegrationPage';
import { WhatsAppCobrancasReportPage } from '@/pages/WhatsAppCobrancasReportPage';
import { GestorCobrancasPage } from '@/pages/GestorCobrancasPage';
import { InternalChatPage } from '@/pages/InternalChatPage';
import { KanbanConfigPage } from '@/pages/KanbanConfigPage';
import { OperadorPerformanceReportPage } from '@/pages/OperadorPerformanceReportPage';
import { ZehMotocaConfigPage } from '@/pages/ZehMotocaConfigPage';
import { DownloadsPage } from '@/pages/DownloadsPage';
import { PushNotificationsPage } from '@/pages/PushNotificationsPage';
import { MercadoZehPage } from '@/pages/MercadoZehPage';
import { DiretoriaPage } from '@/pages/DiretoriaPage';
import { DashboardOficinaPage } from '@/pages/DashboardOficinaPage';
import { DashboardOficinaV2Page } from '@/pages/DashboardOficinaV2Page';
import { DashboardOficinaListaRedirect } from '@/pages/DashboardOficinaListaRedirect';
import { DashboardOficinaIndicadoresPage } from '@/pages/DashboardOficinaIndicadoresPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { IndicacaoPage } from '@/pages/IndicacaoPage';
import { ZehMotocaLandingPage } from '@/pages/ZehMotocaLandingPage';
import { ClienteLoginPage } from '@/pages/cliente/ClienteLoginPage';
import { ClienteDashboardPage } from '@/pages/cliente/ClienteDashboardPage';
import { ClientePerfilPage } from '@/pages/cliente/ClientePerfilPage';
import { ClienteFinanceiroPage } from '@/pages/cliente/ClienteFinanceiroPage';
import { ClienteAtendimentosPage } from '@/pages/cliente/ClienteAtendimentosPage';
import { ClienteIndicacaoPage } from '@/pages/cliente/ClienteIndicacaoPage';
import { ClienteLayout } from '@/components/layout/ClienteLayout';
import { ClienteProtectedRoute } from '@/components/auth/ClienteProtectedRoute';

import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AdminRoute } from '@/components/auth/AdminRoute';
import { GestorRoute } from '@/components/auth/GestorRoute';
import { PainelOficinaRoute } from '@/components/auth/PainelOficinaRoute';
import { HomeRedirect } from '@/components/auth/HomeRedirect';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import { DebugOverlay } from '@/components/DebugOverlay';
import { NotificationModalProvider } from '@/contexts/NotificationModalContext';

function App() {
  const { isAuthenticated } = useAuthStore();
  const { initializeTheme } = useThemeStore();

  useEffect(() => {
    try {
      initializeTheme();
    } catch (error) {
      console.error('Erro ao inicializar tema:', error);
    }
  }, [initializeTheme]);

  console.log('App - Estado de autenticação:', isAuthenticated);

  return (
    <NotificationModalProvider>
      <Routes>
        {/* Public routes */}
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <HomeRedirect /> : <LoginPage />
          } 
        />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
        <Route path="/indicacao" element={<IndicacaoPage />} />
        <Route path="/zehmotoca" element={<ZehMotocaLandingPage />} />
        <Route path="/cliente/login" element={<ClienteLoginPage />} />
        <Route
          path="/cliente"
          element={
            <ClienteProtectedRoute>
              <ClienteLayout />
            </ClienteProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<ClienteDashboardPage />} />
          <Route path="financeiro" element={<ClienteFinanceiroPage />} />
          <Route path="atendimentos" element={<ClienteAtendimentosPage />} />
          <Route path="indicacao" element={<ClienteIndicacaoPage />} />
          <Route path="perfil" element={<ClientePerfilPage />} />
          <Route path="*" element={<Navigate to="/cliente/dashboard" replace />} />
        </Route>

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomeRedirect />} />
          <Route
            path="portal"
            element={
              <RouteErrorBoundary routeName="PortalFly Zeh Motoca">
                <PortalPage />
              </RouteErrorBoundary>
            }
          />
                    <Route 
            path="dashboard" 
            element={
              <RouteErrorBoundary routeName="Dashboard">
                <DashboardPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="kanban" 
            element={
              <RouteErrorBoundary routeName="Kanban">
                <KanbanPageSimple />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="kanban-validacao" 
            element={
              <RouteErrorBoundary routeName="Kanban Validação">
                <KanbanValidationPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="titulos" 
            element={
              <RouteErrorBoundary routeName="Títulos">
                <TitulosPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="usuarios" 
            element={
              <RouteErrorBoundary routeName="Usuários">
                <UsersPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="empresas"
            element={
              <RouteErrorBoundary routeName="Empresas">
                <CompaniesPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="clientes-fornecedores" 
            element={
              <RouteErrorBoundary routeName="Clientes/Fornecedores">
                <ClientesFornecedoresPageSimple />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="configuracoes" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Configurações">
                  <ConfigPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="configuracoes/aplicativo-zehmotoca" 
            element={
              <GestorRoute>
                <RouteErrorBoundary routeName="Aplicativo ZehMotoca">
                  <ZehMotocaConfigPage />
                </RouteErrorBoundary>
              </GestorRoute>
            } 
          />
          <Route 
            path="kanban-config" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Configuração de Kanbans">
                  <KanbanConfigPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="importacao" 
            element={
              <RouteErrorBoundary routeName="Importação">
                <ImportPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="relatorios" 
            element={
              <RouteErrorBoundary routeName="Relatórios">
                <ReportsPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="whatsapp-cobrancas-report" 
            element={
              <GestorRoute>
                <RouteErrorBoundary routeName="Relatório de Cobranças WhatsApp">
                  <WhatsAppCobrancasReportPage />
                </RouteErrorBoundary>
              </GestorRoute>
            } 
          />
          <Route 
            path="operador-performance-report" 
            element={
              <GestorRoute>
                <RouteErrorBoundary routeName="Desempenho do Operador">
                  <OperadorPerformanceReportPage />
                </RouteErrorBoundary>
              </GestorRoute>
            } 
          />
          <Route 
            path="kanban-etapas" 
            element={
              <RouteErrorBoundary routeName="Kanban Etapas">
                <KanbanEtapasPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="test" 
            element={
              <RouteErrorBoundary routeName="Teste">
                <TestPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="log-acesso" 
            element={
              <RouteErrorBoundary routeName="Logs de Acesso">
                <LogAcessoPage />
              </RouteErrorBoundary>
            } 
          />
                    <Route 
            path="whatsapp-integration"
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Integração WhatsApp">
                  <WhatsAppIntegrationPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="email-automation" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Automação de Emails">
                  <EmailAutomationPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="email-reports" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Relatórios de Email">
                  <EmailReportsPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="email-ab-testing" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="A/B Testing de Emails">
                  <EmailABTestingPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="email-personalization" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Personalização de Templates">
                  <EmailPersonalizationPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="email-analytics" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Dashboard de Analytics de Email">
                  <EmailAnalyticsDashboard />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="gestor-cobrancas" 
            element={
              <RouteErrorBoundary routeName="Gestor de Cobranças">
                <GestorCobrancasPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="internal-chat" 
            element={
              <RouteErrorBoundary routeName="Chat Interno">
                <InternalChatPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="downloads" 
            element={
              <AdminRoute>
                <RouteErrorBoundary routeName="Downloads">
                  <DownloadsPage />
                </RouteErrorBoundary>
              </AdminRoute>
            } 
          />
          <Route 
            path="push-notifications" 
            element={
              <GestorRoute>
                <RouteErrorBoundary routeName="Notificações Push">
                  <PushNotificationsPage />
                </RouteErrorBoundary>
              </GestorRoute>
            } 
          />
          <Route 
            path="mercado-zeh" 
            element={
              <GestorRoute>
                <RouteErrorBoundary routeName="Mercado do Zeh">
                  <MercadoZehPage />
                </RouteErrorBoundary>
              </GestorRoute>
            } 
          />
          <Route
            path="diretoria"
            element={
              <GestorRoute>
                <RouteErrorBoundary routeName="Diretoria">
                  <DiretoriaPage />
                </RouteErrorBoundary>
              </GestorRoute>
            }
          />
          <Route 
            path="dashboard-oficina" 
            element={
              <PainelOficinaRoute>
                <RouteErrorBoundary routeName="Painel Oficina">
                  <DashboardOficinaPage />
                </RouteErrorBoundary>
              </PainelOficinaRoute>
            } 
          />
          <Route
            path="dashboard-oficina/v2"
            element={
              <PainelOficinaRoute>
                <RouteErrorBoundary routeName="Painel Oficina v2">
                  <DashboardOficinaV2Page />
                </RouteErrorBoundary>
              </PainelOficinaRoute>
            }
          />
          <Route
            path="dashboard-oficina/lista"
            element={
              <PainelOficinaRoute>
                <DashboardOficinaListaRedirect />
              </PainelOficinaRoute>
            }
          />
          <Route
            path="dashboard-oficina/indicadores"
            element={
              <PainelOficinaRoute>
                <RouteErrorBoundary routeName="Painel Oficina (legado)">
                  <DashboardOficinaIndicadoresPage />
                </RouteErrorBoundary>
              </PainelOficinaRoute>
            }
          />
          <Route path="painel-oficina" element={<Navigate to="/dashboard-oficina" replace />} />
          <Route path="painel-oficina/lista" element={<Navigate to="/dashboard-oficina" replace />} />
          
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
      
      {/* Debug overlay em desenvolvimento */}
      <DebugOverlay />
    </NotificationModalProvider>
  );
}

export default App;
